export enum CouponStatus {
    EXPIRED = 'EXPIRED_CODE',
    INVALID = 'INVALID_CODE',
    SUCCESS_MANUAL = 'success_manual',
    SUCCESS_DIRECT = 'success_direct',
    FAIL_MANUAL_INSUFFICIENT_CART_VALUE = 'fail_manual_insufficient_cart_value',
    FAIL_DIRECT_INSUFFICIENT_CART_VALUE = 'fail_direct_insufficient_cart_value',
}
